import React from "react";
import "../Feature/Feature.css";

const features = [
  {
    id: 1,
    title: "Auto Lock on EMI Default",
    description:
      "Automatically locks the mobile device if EMI payments are missed, ensuring financial commitments are met",
  },
  {
    id: 2,
    title: "Customizable Lock Rules",
    description:
      "Set lock rules and payment reminders based on user-specific loan or EMI schedules.",
  },
  {
    id: 3,
    title: "Secure Device Access",
    description:
      "Ensures device data is protected while locked, providing a secure environment until payment completion.",
  },
  {
    id: 4,
    title: "Instant Unlock on Payment",
    description:
      "Instantly unlocks the device upon successful EMI payment confirmation, offering a seamless experience",
  },
  {
    id: 5,
    title: "Remote Management",
    description:
      "Allows remote access for administrators or lenders to monitor and enforce device locking rules.",
  },
  {
    id: 6,
    title: "User-Friendly Interface",
    description:
      "Simple and intuitive dashboard for easy tracking of payment schedules and device status.",
  },
];

const Feature = () => {
  return (
    <div className="section harsafe-servicess-section pt-60">
      <div className="container">
        <div className="services-wrap">
          <div className="section-title text-center">
            <h3 className="sub-title">Features</h3>
            <h2 className="title">Key Features Overview</h2>
          </div>
          <div className="strengthSec">
            <div className="row lt-ued">
              {features.map((feature) => (
                <div key={feature.id} className="col-md-6 col-xl-4 col-sm-6 mb-4">
                  <div className="cb-challenges">
                    <span className="chicon-color">{feature.id}</span>
                    <h5>{feature.title} <span className="bordy"></span></h5>
                    <p>{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Feature;
